import ShortcastEpisodePage from "./components/page"
import VueI18n from "vue-i18n"
import store from "@/store/"

export default (Vue, { locale, episodeData, shortcastData }) => {
  return new Vue({
    name: "ShortcastEpisodePlayer",
    store,
    i18n: new VueI18n({ locale }),
    render: (h) =>
      h(ShortcastEpisodePage, {
        props: {
          episode: episodeData,
          shortcast: shortcastData
        }
      })
  })
}
